import { TrackByFunction } from '@angular/core';

import { StateToken } from '@ngxs/store';

import { KeyOf } from '@app/core/utilities/typescript.utilities';
import { ApiFilterValues, ApiPaginationResponse, ApiSearchValues } from '@app/core/models/api.models';

export interface ApiMutatorStateModel<T extends object = object> {
  loading: boolean;
  refreshing: boolean;
  firstLoad: boolean;
  pagination?: ApiPaginationResponse<T>;
  total?: number;
  noData?: boolean;
  loadingMore?: boolean;
  canLoadMore?: boolean;
  search?: string | number;
  sortValues?: Partial<Record<KeyOf<T>, number>>;
  filterValues?: ApiFilterValues<T>;
  searchValues?: ApiSearchValues<T>;
  trackById?: TrackByFunction<T>;
}

export interface ApiStateModel<T extends object = object> {
  metadata: Record<string, ApiMutatorStateModel<T>>;
}

export const API_STATE_TOKEN = new StateToken<ApiStateModel>('api');
